/* Lil Cradle mini: wishlist, mobile search trigger, sticky add-to-cart */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) document.documentElement.classList.add('lc-js');

  var KEY = 'lc_wishlist';

  /* ---------- wishlist storage ---------- */
  function readList() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function writeList(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function has(handle) {
    return readList().indexOf(handle) !== -1;
  }
  function toggle(handle) {
    var list = readList();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    writeList(list);
    return i === -1;
  }

  function syncHearts() {
    document.querySelectorAll('[data-lc-heart]').forEach(function (btn) {
      var on = has(btn.dataset.handle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var n = readList().length;
    document.querySelectorAll('[data-lc-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-lc-heart]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      toggle(heart.dataset.handle);
      syncHearts();
      return;
    }
    var search = e.target.closest('[data-lc-search]');
    if (search) {
      var summary = document.querySelector('.header__search summary');
      if (summary) {
        summary.click();
        setTimeout(function () {
          var input = document.querySelector('.search-modal .search__input');
          if (input) input.focus();
        }, 200);
      } else {
        window.location.href = '/search';
      }
    }
  });

  /* ---------- wishlist page ---------- */
  function money(cents) {
    var v = cents / 100;
    return '₹' + v.toLocaleString('en-IN', { maximumFractionDigits: v % 1 ? 2 : 0 });
  }

  function imgUrl(src) {
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=600';
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-lc-wishlist]');
    if (!root) return;
    var grid = root.querySelector('[data-lc-wishlist-grid]');
    var empty = root.querySelector('[data-lc-wishlist-empty]');
    var handles = readList();
    grid.innerHTML = '';
    if (!handles.length) {
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var found = 0;
      products.forEach(function (p, i) {
        if (!p) {
          var list = readList();
          var idx = list.indexOf(handles[i]);
          if (idx !== -1) {
            list.splice(idx, 1);
            writeList(list);
          }
          return;
        }
        found++;
        var variant = p.variants.filter(function (v) {
          return v.available;
        })[0];
        var li = document.createElement('li');
        li.className = 'lc-wish-item';
        li.innerHTML =
          '<a class="lc-wish-item__media" href="' + p.url + '">' +
          (p.featured_image
            ? '<img loading="lazy" width="600" height="800" alt="" src="' + imgUrl(p.featured_image) + '">'
            : '') +
          '</a>' +
          '<button type="button" class="lc-heart is-active" data-lc-remove="' + p.handle + '" aria-label="Remove from wishlist">' +
          '<span class="svg-wrapper"></span></button>' +
          '<div class="lc-wish-item__info"><a class="lc-wish-item__title" href="' + p.url + '"></a>' +
          '<span class="lc-wish-item__price">' + money(p.price) + '</span></div>' +
          '<button type="button" class="button button--primary lc-wish-item__add" ' +
          (variant ? 'data-variant="' + variant.id + '">Add to cart' : 'disabled>Sold out') +
          '</button>';
        li.querySelector('.lc-wish-item__title').textContent = p.title;
        var heartIcon = document.querySelector('.header__icon--wishlist .svg-wrapper');
        if (heartIcon) li.querySelector('.lc-heart .svg-wrapper').innerHTML = heartIcon.innerHTML;
        grid.appendChild(li);
      });
      if (!found) empty.hidden = false;
      syncHearts();
    });

    if (!root.dataset.bound) {
      root.dataset.bound = '1';
      root.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-lc-remove]');
        if (rm) {
          e.preventDefault();
          var list = readList();
          var idx = list.indexOf(rm.dataset.lcRemove);
          if (idx !== -1) list.splice(idx, 1);
          writeList(list);
          renderWishlistPage();
          syncHearts();
          return;
        }
        var add = e.target.closest('.lc-wish-item__add[data-variant]');
        if (add) addToCart(add, add.dataset.variant);
      });
    }
  }

  function addToCart(btn, variantId) {
    var cartEl = document.querySelector('cart-drawer');
    var sections = cartEl && cartEl.getSectionsToRender
      ? cartEl.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var label = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200 && !data.items) throw new Error(data.description || 'error');
        if (cartEl && cartEl.renderContents && data.sections) {
          cartEl.renderContents(data);
        } else {
          window.location.href = '/cart';
        }
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.textContent = label;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  }

  /* ---------- product page: heart + sticky add to cart ---------- */
  function productPage() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var submit = document.querySelector('.product-form__submit');
    if (!m || !submit) return;
    var handle = decodeURIComponent(m[1]);

    var title = document.querySelector('.product__title');
    if (title && !document.querySelector('.lc-heart--pdp')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lc-heart lc-heart--pdp';
      b.setAttribute('data-lc-heart', '');
      b.setAttribute('aria-label', 'Add to wishlist');
      b.setAttribute('aria-pressed', 'false');
      b.dataset.handle = handle;
      var icon = document.querySelector('.header__icon--wishlist .svg-wrapper');
      b.innerHTML = '<span class="svg-wrapper">' + (icon ? icon.innerHTML : '') + '</span>';
      title.appendChild(b);
      syncHearts();
    }

    if (document.querySelector('.lc-sticky-atc')) return;
    var bar = document.createElement('div');
    bar.className = 'lc-sticky-atc';
    bar.innerHTML = '<div class="lc-sticky-atc__price" aria-live="polite"></div>' +
      '<button type="button" class="button button--primary lc-sticky-atc__btn"></button>';
    document.body.appendChild(bar);
    var priceEl = bar.querySelector('.lc-sticky-atc__price');
    var btn = bar.querySelector('.lc-sticky-atc__btn');

    function refresh() {
      var p = document.querySelector('.product__info-container .price');
      if (p) {
        var last = p.querySelector('.price-item--last') || p.querySelector('.price-item--regular');
        priceEl.textContent = last ? last.textContent.trim() : '';
      }
      btn.textContent = submit.textContent.replace(/\s+/g, ' ').trim() || 'Add to cart';
      btn.disabled = submit.disabled || submit.hasAttribute('disabled');
    }
    refresh();
    var info = document.querySelector('.product__info-container');
    if (info && window.MutationObserver) {
      new MutationObserver(refresh).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    }
    btn.addEventListener('click', function () {
      submit.click();
    });
    function onScroll() {
      bar.classList.toggle('is-visible', submit.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }


  /* ---------- motion: scroll reveal, header shadow, cart bump ---------- */
  var REVEAL = [
    '.title-wrapper-with-link', '.collection-list__item', '.multicolumn-list__item', '.rich-text__wrapper',
    '.image-with-text__content', '.image-with-text__media-item', '.footer-block', '.lc-reviews', '.lc-wishlist__title',
    '.collection-hero__inner', '.product__info-wrapper', '.related-products .title-wrapper-with-link'
  ].join(',');

  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var i = 0;
    document.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.classList.contains('lc-reveal') || el.closest('.scroll-trigger:not(.lc-reveal)') || el.closest('.lc-hero')) return;
      el.classList.add('lc-reveal');
      el.style.setProperty('--lc-delay', (i++ % 4) * 70 + 'ms');
      io.observe(el);
    });
    /* images ease in with a slow zoom (uses the separate "scale" property, so hover transforms still work) */
    document.querySelectorAll('.image-with-text__media img, .collection-list .card__media img, .banner__media img').forEach(function (img) {
      if (img.closest('.lc-hero')) return;
      img.classList.add('lc-zoom');
      io.observe(img);
    });
    /* safety net: never leave content hidden if observers misbehave */
    setTimeout(function () {
      document.querySelectorAll('.lc-reveal:not(.is-visible), .lc-zoom:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-visible');
      });
    }, 4000);
  }

  function initHeaderShadow() {
    var on = false;
    function check() {
      var now = window.scrollY > 8;
      if (now !== on) {
        on = now;
        document.documentElement.classList.toggle('lc-scrolled', on);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  function initCartBump() {
    var target = document.getElementById('cart-icon-bubble');
    if (!target || !window.MutationObserver) return;
    new MutationObserver(function () {
      target.classList.remove('lc-bump');
      void target.offsetWidth;
      target.classList.add('lc-bump');
    }).observe(target, { childList: true, subtree: true, characterData: true });
  }

  function initMotion() {
    initReveal();
    initHeaderShadow();
    initCartBump();
  }

  function init() {
    syncHearts();
    renderWishlistPage();
    productPage();
    initMotion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  var t;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(syncHearts, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('storage', syncHearts);
  window.addEventListener('pageshow', syncHearts);
})();
